module.exports = __webpack_public_path__ + "static/img/empleadorhome-1024x768.356909f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/home/empleadorhome-1024x768.jpg
// module id = ISDi
// module chunks = 47